import { AddOnsTemplate1 } from '@/components/add-ons/template1';
import { SpecialEventsList } from '@/components/special-events/list';
import { areasList } from '@/styles/components/blocks.module.scss';

export const SpecialEventsGrid = () => {
  return (
    <AddOnsTemplate1 title="Special Events" subtitle="From corporate gatherings to private celebrations, our special events are tailored to make your time on the water truly unforgettable.">
      <ul className={areasList}>
        <SpecialEventsList />
      </ul>
    </AddOnsTemplate1>
  );
};
